var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('Form')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',[_c('h1',[_vm._v("New API Key")])])
}]

export { render, staticRenderFns }